module.exports = __webpack_public_path__ + "img/one.b8e74102.svg";